import { ReactNode } from 'react';

import { cn } from '@/lib/utils';
import { Card, CardAction, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export interface SectionCardProps {
  title?: ReactNode;
  description?: ReactNode;
  /** At the header's end: a link, a filter, a button. */
  action?: ReactNode;
  className?: string;
  contentClassName?: string;
  /** Let a table run edge to edge. */
  flush?: boolean;
  children: ReactNode;
  testId?: string;
}

/** A titled block of a page: white, hairline, the title and one line on what it shows. */
export function SectionCard({ title, description, action, className, contentClassName, flush, children, testId }: SectionCardProps) {
  return (
    <Card className={cn('gap-4', flush && 'pb-0', className)} data-testid={testId}>
      {(title || action) && (
        <CardHeader>
          {title && <CardTitle className="text-sm">{title}</CardTitle>}
          {description && <CardDescription className="text-xs">{description}</CardDescription>}
          {action && <CardAction>{action}</CardAction>}
        </CardHeader>
      )}
      <CardContent className={cn(flush && 'px-0', contentClassName)}>{children}</CardContent>
    </Card>
  );
}
